import type { ReOSDatabase } from "./types";

export function normalizeDatabase(database: Partial<ReOSDatabase>): ReOSDatabase {
  return {
    currentUserID: database.currentUserID,
    activeWorkspaceID: database.activeWorkspaceID,
    users: database.users ?? [],
    workspaces: database.workspaces ?? [],
    workspaceMembers: database.workspaceMembers ?? [],
    subscriptions: database.subscriptions ?? [],
    entitlements: database.entitlements ?? [],
    inventoryItems: database.inventoryItems ?? [],
    itemPhotos: database.itemPhotos ?? [],
    storedAssets: database.storedAssets ?? [],
    marketplaceAccounts: database.marketplaceAccounts ?? [],
    marketplaceListings: database.marketplaceListings ?? [],
    channelObservations: database.channelObservations ?? [],
    channelSyncRuns: database.channelSyncRuns ?? [],
    channelPhotoJobs: database.channelPhotoJobs ?? [],
    marketplaceImportRuns: database.marketplaceImportRuns ?? [],
    marketplaceImportRecords: database.marketplaceImportRecords ?? [],
    sales: database.sales ?? [],
    notifications: database.notifications ?? [],
    categories: database.categories ?? []
  };
}
